export const allNotes = ["C", "D", "E", "F", "G", "A", "B", "Cb", "Db", "Eb", "Fb", "Gb", "Ab", "Bb", "C#", "D#", "E#", "F#", "G#", "A#", "B#"]

export const noteLens = [
    { name: "1n", value: 1, num: 1, mod: 'n' },
    { name: "2n", value: 0.5, num: 2, mod: 'n' },
    { name: "2n.", value: 0.5, num: 2, mod: 'n' },
    { name: "4n", value: 0.25, num: 4, mod: 'n' },
    { name: "4n.", value: 0.40, num: 4, mod: 'n' },
    { name: "8n", value: 0.08, num: 8, mod: 'n' },
    { name: "16n", value: 0.04, num: 16, mod: 'n' }
]